export default {
  props: {
    tab: {
      type: String,
      default: 'all'
    },
    rowData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      showDialog: false
    };
  },
  computed: {
    patientName() {
      const {
        firstname,
        lastname
      } = this.rowData;
      return `${firstname} ${lastname}`;
    }
  },
  methods: {
    getDate(date) {
      if (date == '-') {
        return '-';
      }
      return new Date(date * 1000).toDateString();
    },
    confirm() {
      if (['refundrequest', 'refundrequest-from-allergy'].includes(this.tab)) {
        this.$emit('dismiss-type', this.rowData.orderid, this.tab);
        this.showDialog = false;
      } else {
        this.$emit('dismiss', this.rowData.id);
        this.showDialog = false;
      }
    }
  }
};